export default __webpack_public_path__ + "assets/8f9270cc2f2cce57e2b919c5af663ae7.svg";